import { render, staticRenderFns } from "./KitchenBanner.vue?vue&type=template&id=5a563077&"
import script from "./KitchenBanner.vue?vue&type=script&lang=js&"
export * from "./KitchenBanner.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports